import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class MatchEventGoalDenied extends DomainEvent<DeletedEntity> {}
